import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const CreateUser = lazy(() => import("./CreateUser"));
const ViewUsers = lazy(() => import("./ViewUsers"));
const DetailUser = lazy(() => import("./DetailUser"));

const L = DefaultLayout;
const W = withSuspense;

export function getUserRoutes() {
  return [
    { path: "/create-user", layout: L, element: W(CreateUser) },
    { path: "/edit-user/:id", layout: L, element: W(CreateUser) },
    { path: "/view-users", layout: L, element: W(ViewUsers) },
    { path: "/user-details/:id", layout: L, element: W(DetailUser) },
  ];
}
